import {Route, RouteConfig} from "vue-router";

const SupportIndex = () => import('../views/support/SupportIndex.vue');
const SupportList = () => import('../views/support/SupportList.vue');
const SupportView = () => import('../views/support/SupportView.vue');
const SupportAltisLife = () => import('../views/support/game/SupportAltisLife.vue');
const SupportAltisLifeIndex = () => import('../views/support/game/altis_life/SupportAltisLifeIndex.vue');
const SupportAltisLifeRecoverVehicle = () => import('../views/support/game/altis_life/SupportAltisLifeRecoverVehicle.vue');

let support: RouteConfig[] = [
    {
        name: 'support',
        path: '/support',
        component: SupportIndex,
        redirect: {name: 'support-arma'},
        meta: {
            allowLoggedOut: true,
        },
        children: [
            {
                name: 'support-arma',
                path: '/support/game/arma',
                component: SupportAltisLife,
                redirect: {name: 'support-arma-index'},
                meta: {
                    allowLoggedOut: true,
                },
                children: [
                    {
                        name: 'support-arma-index',
                        path: '/support/game/arma/index',
                        component: SupportAltisLifeIndex,
                        meta: {
                            allowLoggedOut: true,
                        },
                    },
                    {
                        name: 'support-arma-recover-vehicle',
                        path: '/support/game/arma/recover-vehicle',
                        component: SupportAltisLifeRecoverVehicle,
                        meta: {
                            allowLoggedOut: true,
                        },
                    }
                ],
            }
        ]
    },
    {
        name: 'support-list',
        path: '/support/list',
        component: SupportList,
        meta: {
            allowLoggedOut: false,
        },
    },
    {
        name: 'support-case-view',
        path: '/support/view/:id?',
        component: SupportView,
        meta: {
            allowLoggedOut: false,
        },
        props(route: Route)
        {
            return {
                id: parseInt(route.params.id) || 0,
            };
        },
    },
];

export default support;
